// React
import { useTranslation } from "react-i18next";

// MUI
import { Alert, AlertTitle, Stack } from "@mui/material";
import { CancelOutlined } from "@mui/icons-material";

// QR Components
import { QRCloseButton } from "../QRCloseButton";
import { MNButton } from "Common/Components";
import { QR_STATES } from "Constants/QRConstants";
import { useQR } from "../QRContext";

/**
 * @brief QR Code failure dialog
 */
export const QRCodeFail = () => {
  const { setQRState } = useQR();
  const { t } = useTranslation();

  return (
    <Stack alignItems="center" spacing={2}>
      <Alert
        severity="error"
        iconMapping={{
          error: <CancelOutlined fontSize="inherit" />,
        }}
      >
        <AlertTitle>{t("qrcode.scanFailed")}</AlertTitle>
        {t("qrcode.scanFailedDirections")}
      </Alert>
      <Stack
        direction={{ xs: "column-reverse", sm: "row" }}
        spacing={{ xs: 1.5, sm: 2 }}
        sx={{ justifyContent: "flex-end", alignItems: "center" }}
      >
        <QRCloseButton />
        <MNButton onClick={() => setQRState(QR_STATES.OPEN)}>
          {t("qrcode.scanAgain")}
        </MNButton>
      </Stack>
    </Stack>
  );
};
